import { StepName } from '@/state/state.types';

type IsConsultationFromStatic = {
  stepName?: StepName;
};

export default function isConsultationFromStatic({ stepName }: IsConsultationFromStatic): boolean {
  switch (stepName) {
    case StepName.product:
    case StepName.validation:
    case StepName.congrats_first_step:
    case StepName.checkout:
      return true;
    default:
      return false;
  }
}
